import { invokeRPC } from './socket.js'

export function createSheet(data) {
  return invokeRPC('viewSheets', 'createSheet', data)
}

export function createHeroCards(data) {
  return invokeRPC('viewSheets', 'createHeroCards', data)
}

export function getSheetsForView(viewId) {
  return invokeRPC('viewSheets', 'getSheetsForView', { view_id: viewId })
}

export function deleteSheet(id) {
  return invokeRPC('viewSheets', 'deleteSheet', { id: id })
}

export function deleteHeroCardsForView(id) {
  return invokeRPC('viewSheets', 'deleteHeroCardsForView', { id: id })
}

export function deleteHeroCardColumn(id) {
  return invokeRPC('viewSheets', 'deleteHeroCardColumn', { id: id })
}

export function updateSheet(data) {
  return invokeRPC('viewSheets', 'updateSheet', data)
}